import { createGlobalStyle } from "styled-components";
import { globalStyles } from "twin.macro";

// ✅ Import fonts so Webpack can bundle them
import MehrWOFF from "../fonts/MehrNastaliqWeb.woff";
import JameelTTF from "../fonts/JameelNooriNastaleeqRegular.ttf";

const GlobalStyles = createGlobalStyle(
  globalStyles,
  `
  :root {
    --primary-color: #C78A41;       /* Golden-brown from Jamia feedback */
    --secondary-color: #2F5E4E;     /* Deep green (calm and Islamic traditional) */
    --bg-color: #FFF9F4;            /* Soft cream background */
    --text-color: #222;             /* Neutral dark for readability */
  }

  @font-face {
    font-family: 'CustomFont';
    src: url(${MehrWOFF}) format("woff");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'JameelFont';
    src: url(${JameelTTF}) format("truetype");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", 'CustomFont', serif;
    background-color: var(--bg-color);
    color: var(--text-color);
    font-size: 16px;
    line-height: 1.6;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
  }

  a {
    color: var(--primary-color);
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  h1, h2, h3, h4, h5, h6, p {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", 'CustomFont', serif;
    color: var(--secondary-color);
    margin-top: 0;
  }

  .btn-primary {
    background-color: var(--primary-color);
    color: #fff;
    padding: 0.75rem 1.5rem;
    border-radius: 0.375rem;
    transition: background-color 0.3s;
  }

  .btn-primary:hover {
    background-color: #b07437;
  }

  .btn-secondary {
    background-color: var(--secondary-color);
    color: #fff;
    padding: 0.75rem 1.5rem;
    border-radius: 0.375rem;
    transition: background-color 0.3s;
  }

  .btn-secondary:hover {
    background-color: #264b3e;
  }

  .ReactModal__Overlay {
    transition: transform 300ms ease-in-out;
    transform: scale(0);
  }

  .ReactModal__Overlay--after-open {
    transform: scale(1);
  }

  .ReactModal__Overlay--before-close {
    transform: scale(0);
  }
`
);

export default GlobalStyles;
